import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/services/user.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  showcurrentpassErrorMsg: any;
  oldPassword: any;
  shownewpassErrorMsg: any;
  newPassword: any;
  showconfirmpassErrorMsg:any;
  confirmPassword:any;
  error: any;
  error5: any;

  constructor(private router: Router,public user:UserService) { }

  ngOnInit(): void {
  }
  currentpassErrorMsg() 
  {
    if (!this.oldPassword) { this.showcurrentpassErrorMsg = true; } else { this.showcurrentpassErrorMsg = false }
  }
  newpassErrorMsg() 
  {
    if (!this.newPassword) { this.shownewpassErrorMsg = true; } else { this.shownewpassErrorMsg = false };
    this.error5="";
  }

  confirmpassErrorMsg() 
  {
    if (!this.confirmPassword) { this.showconfirmpassErrorMsg = true; } else { this.showconfirmpassErrorMsg = false }
  }

  showNew = false;
  typeNew = "password";
  toggleShowNew() {
    this.showNew = !this.showNew;
    if (this.showNew) {
      this.typeNew = "text";
    }
    else {
      this.typeNew = "password";
    }
  }
  showConfirm = false;
  typeConfirm = "password";
  toggleShowConfirm() {
    this.showConfirm = !this.showConfirm;
    if (this.showConfirm) {
      this.typeConfirm = "text";
    }
    else {
      this.typeConfirm = "password";
    }
  }
  showCurrent = false;
  typeCurrent = "password";
  toggleShowCurrent() {
    this.showCurrent = !this.showCurrent;
    if (this.showCurrent) {
      this.typeCurrent = "text";
    }
    else {
      this.typeCurrent = "password";
    }
  }
  passwordChange() 
  {
      var flag = true;
      if (!this.oldPassword || this.oldPassword == "") { this.showcurrentpassErrorMsg = true; flag = false }
      if (!this.newPassword || this.newPassword == "") { this.shownewpassErrorMsg = true; flag = false }
      if (!this.confirmPassword || this.confirmPassword == "") { this.showconfirmpassErrorMsg = true; flag = false }

    if(this.oldPassword == this.newPassword){
      Swal.fire('Current password and New password cannot be same!');
      flag = false;
        }
    if(this.newPassword != this.confirmPassword){
       Swal.fire('New password and Confirm password need to be same!');
       flag = false;
        }
        if (flag == true) 
        {
          this.user.updatePassword(this.oldPassword, this.newPassword)
      .pipe()
      .subscribe(
          data => {
            if(data.success==true){
           this.router.navigateByUrl('/')
         //  Swal.fire('Password is updated successfully!')
          Swal.fire("", data.data)
            }
          },error=>{
            
              if(error.status == 400 || error.status==417){
                  this.error=error.error.data;
               }
               else{
 
                 this.error="Something went wrong";
               }
           
              },()=>{});

        }
   }
   passwordValidate(pass){
    this.error5=""
    var re = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
    
  if (!re.test(pass.toUpperCase())) {
  this.error5="Please enter valid Password!"
  }
  // if (!re.test(pass.match())){
  //   this.error5="Please enter valid Password"
  //   }
    if (pass.length <8){
      this.error5="Please enter valid Password!"
      }
}
  
}
